module.exports = __webpack_public_path__ + "img/compact.5951fcf4.png";